import React from 'react';

import { Link } from "react-router-dom";
import AxiosClient from '../../assets/AxiosClient';

const FillesRow = ({ id, title, description , conference , active }) => {
  const handleQRDownload = async ()=> { 
    const confirmed = window.confirm('Do you want to download this file?');
    
    if (!confirmed) {
      // User cancelled the download
      return;
    }
    try {
      const response = await AxiosClient.get(`GenerateQr/file/${id}`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'qr-code.png');
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  }
  const handleFileDownload = async () => {
    const confirmed = window.confirm('Do you want to download this file?');
    
    if (!confirmed) {
      // User cancelled the download
      return;
    }
    try {
      // Make GET request to download endpoint
      const response = await AxiosClient.get(`public/${id}/download` , {
        responseType: 'blob', // Important to receive response as Blob
      });
      console.log(response);
      // Create a temporary anchor element to trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${title}.pdf`); // Set desired file name
      document.body.appendChild(link);
      link.click();

      // Clean up resources
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('File download error:', error);
      // Handle error (e.g., display error message)
    }
  };
  return (
    <>
      <tr>
        <td className="h1 text-dark">
          <div className=" px-2">
            <div></div>
            <div className="">
              <h6 className="mb-0 ">{title}</h6>
            </div>
          </div>
        </td>
        <td className="h1 text-dark">
          
          <div className="">
            <h6 className="mb-0 "> { active ? "Public" : "UI" }</h6>
          </div>
       
      </td>
     
        <td className="h1 text-dark">
          
            <div className="">
              <h6 className="mb-0 ">{conference.en_title}</h6>
            </div>
         
        </td>
        <td className="align-middle text-center">
          <div className="d-flex align-items-center justify-content-center">
{description}            <div></div>
          </div>
        </td>
        <td className="align-middle">
          <Link to={`./Edite/${id}`} className="btn btn-info m-2">Edit File
          </Link>
          <button onClick={ handleFileDownload} className="btn btn-warning m-2">download
          </button>
          <Link to={`./replace/${id}`} className="btn btn-danger m-2">Replace
          </Link>
          <button onClick={ handleQRDownload} className="btn btn-warning m-2">Qr Generator
          </button>
          <br/>
        </td>
      </tr>
    </>
  );
};

export default FillesRow;